import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=f3ee9192&"
import script from "./AsideMenu.vue?vue&type=script&lang=js&"
export * from "./AsideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ee9192')) {
      api.createRecord('f3ee9192', component.options)
    } else {
      api.reload('f3ee9192', component.options)
    }
    module.hot.accept("./AsideMenu.vue?vue&type=template&id=f3ee9192&", function () {
      api.rerender('f3ee9192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AsideMenu.vue"
export default component.exports